module.exports = __webpack_public_path__ + "static/media/default.2048a305.jpg";